export const GET_LAYOUT_MAP = "GET_LAYOUT_MAP";
export const SET_LAYOUT_MAP = "SET_LAYOUT_MAP";
